// src/components/MainUnclaimedHistory.jsx
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { tabsClasses } from "@mui/material/Tabs";

import UnclaimedDividendHistory from "./UnclaimedDividendHistory";
import SopFaqs from "./SopFaqs";

function MainUnclaimedHistory() {
  const [value, setValue] = useState("1");
  const [breadcrumbText, setBreadcrumbText] = useState("");

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
    { id: "1", label: "Unclaimed Redemption" },
    { id: "2", label: "SOP/FAQs for Unclaimed Amounts" },
  ];

  // Update breadcrumb when tab changes
  useEffect(() => {
    const currentTab = tabs.find((tab) => tab.id === value);
    setBreadcrumbText(currentTab ? currentTab.label : "Unclaimed Redemption");
  }, [value]);

  // Initial URL-based breadcrumb (fallback)
  useEffect(() => {
    const pathnameurl = window.location.pathname;
    const lastSegment = pathnameurl.slice(pathnameurl.lastIndexOf("/") + 1);
    
    // Clean up the URL segment for display
    const cleanedName = lastSegment
      .replace(/-/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2");

    setBreadcrumbText(cleanedName || "Unclaimed Redemption");
  }, []);

  return (
    <section className="navs-and-dividends-section">
      {/* Breadcrumb */}
      <Container>
        <Row>
          <Col>
            <ul className="navigator-arrow">
              <li>
                <a href="/" aria-label="Home">
                  <i className="fa fa-home" aria-hidden="true"></i>
                </a>{" "}
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </li>
              {window.location.pathname !== "/NavsAndIDCW" && (
                <li>{breadcrumbText}</li>
              )}
            </ul>
          </Col>
        </Row>
      </Container>

      {/* Tabs */}
      <Box>
        <TabContext value={value}>
          <Container className="tabs-nav">
            <Row>
              <Col sm={12}>
                <Box sx={{ borderBottom: 0, bgcolor: "background.paper" }}>
                  <TabList
                    onChange={handleTabChange}
                    variant="scrollable"
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                    scrollButtons="auto"
                  >
                    {tabs.map((tab) => (
                      <Tab key={tab.id} label={tab.label} value={tab.id} />
                    ))}
                  </TabList>
                </Box>
              </Col>
            </Row>
          </Container>

          <TabPanel value="1">
            <UnclaimedDividendHistory />
          </TabPanel>
          <TabPanel value="2">
            <SopFaqs />
          </TabPanel>
        </TabContext>
      </Box>
    </section>
  );
}

export default MainUnclaimedHistory;